/* eslint-disable import/prefer-default-export, react/display-name */
import React from 'react';
import { useTranslation } from './useTranslation';

export const withTranslation = () => Component => props => {
    const { t } = useTranslation();
    return <Component {...props} t={t} />;
};
